export const loginInternalUser = (session) => {
    return {
        type: "LOGIN_INTERNAL_USER",
        payload: session,
    };
};

export const logoutInternalUser = () => {
    return {
        type: "LOGOUT_INTERNAL_USER",
    };
};
